export default __webpack_public_path__ + "assets/images/c5a2abce3acd309d00fdb86b905ef24e.svg";